// Regular colors
export const primaryLight = '#F0F8F5';
export const primaryMain = '#1E4637';
export const primaryDark = '#18382C';
export const secondaryLight = '#FDE9F3';
export const secondaryMain = '#FAC8E1';
export const grey100 = '#F5F5F5';
export const grey200 = '#E3E3E3';
export const grey300 = '#A3A3A3';
export const grey400 = '#595959';
export const grey600 = '#000000';
export const grey900 = '#171717';
export const white = '#FFFFFF';
export const successLight = '#E6F2EB';
export const successMain = '#007E35';
export const successDark = '#005724';
export const errorMain = '#B00020';
export const errorLight = '#F7E6E9';
export const errorDark = '#99001C';
export const infoMain = '#0367A6';
export const infoLight = '#E6F0F6';
export const infoDark = '#034E7C';
export const warningMain = '#FA9F47';
export const warningLight = '#FFF5ED';
export const warningDark = '#814004';
// Text colors
export const regularTextColor = '#323232';
export const grayTextColor = '#727272';
export const placeholderTextColor = '#A3A3A3';
// Component specific
export const remoteLevelCardBg = '#F7F8F8';
export const borderColor = '#cbcbcb';

export const palette = {
  primary: {
    main: primaryMain,
    light: primaryLight,
    dark: primaryDark,
  },
  secondary: {
    main: secondaryMain,
    light: secondaryLight,
  },
  grey: {
    100: grey100,
    200: grey200,
    300: grey300,
    400: grey400,
    600: grey600,
    900: grey900,
    A100: white,
  },
  success: {
    main: successMain,
    light: successLight,
    dark: successDark,
  },
  error: {
    main: errorMain,
    light: errorLight,
    dark: errorDark,
  },
  info: {
    main: infoMain,
    light: infoLight,
    dark: infoDark,
  },
  warning: {
    main: warningMain,
    light: warningLight,
    dark: warningDark,
  },
  text: {
    regular: regularTextColor,
    secondary: grayTextColor,
    placeholder: placeholderTextColor,
  },
  // component specific
  remoteLevelCard: {
    bg: remoteLevelCardBg,
  },
  borderColor: {
    main: borderColor,
  },
};
